import { supabase } from '../lib/supabase';

// Fetch tenant config with branding + feature flags
export const tenantService = {
  async getTenantConfigBySlug(slug) {
    if (!slug) return null;

    const { data, error } = await supabase
      ?.from('tenants')
      ?.select(`
        id,
        slug,
        name,
        primary_domain,
        tenant_branding:tenant_branding(*),
        tenant_features:tenant_features(*)
      `)
      ?.eq('slug', slug)
      ?.maybeSingle();

    if (error) throw error;
    if (!data) return null;

    return {
      id: data?.id,
      slug: data?.slug,
      name: data?.name,
      primaryDomain: data?.primary_domain,
      branding: data?.tenant_branding ? {
        logoUrl: data.tenant_branding.logo_url,
        faviconUrl: data.tenant_branding.favicon_url,
        primaryColor: data.tenant_branding.primary_color,
        secondaryColor: data.tenant_branding.secondary_color,
        backgroundColor: data.tenant_branding.background_color,
        textColor: data.tenant_branding.text_color,
        typography: data.tenant_branding.typography,
      } : null,
      features: data?.tenant_features ? {
        enableGamification: !!data.tenant_features.enable_gamification,
        enablePhoneSequences: !!data.tenant_features.enable_phone_sequences,
        enableLiveCoaching: !!data.tenant_features.enable_live_coaching,
        enableObjectionDrills: !!data.tenant_features.enable_objection_drills,
        enableScripts: !!data.tenant_features.enable_scripts,
        enableMicroLessons: !!data.tenant_features.enable_micro_lessons,
        enableUgc: !!data.tenant_features.enable_ugc,
        enableRoleplay: !!data.tenant_features.enable_roleplay,
        enableLeaderboards: !!data.tenant_features.enable_leaderboards,
        enableConversationAnalyzer: !!data.tenant_features.enable_conversation_analyzer,
        enableMegaTrainer: !!data.tenant_features.enable_mega_trainer,
      } : {},
    };
  },
};

export default tenantService;
